import { callApi } from 'services/api/api'
import { toastStore } from 'stores/toast'
import { TOAST_TYPE } from 'utils/constants'
import { baseURL } from 'services/api/apiConfig'
import { appSelected } from 'stores/navigation'

let selectedApplication = 'physician'
appSelected.subscribe(value => {
  if (value?.toLocaleLowerCase() === 'app') {
    selectedApplication = 'app'
  } else {
    selectedApplication = 'physician'
  }
})

export const getMarketModelingScenarios = async () => {
  try {
    return await callApi(`${baseURL}/market-modeling/${selectedApplication}/scenarios`, 'GET')
  } catch (error) {
    toastStore.createToast(TOAST_TYPE.ERROR, 'Server error', 'Error getting market modeling scenarios')
    console.error(error)
    return []
  }
}

export const getMarketModelingData = async payload => {
  try {
    return await callApi(`${baseURL}/market-modeling/${selectedApplication}/data`, 'POST', payload)
  } catch (error) {
    toastStore.createToast(TOAST_TYPE.ERROR, 'Server error', 'Error getting market modeling data')
    console.error(error)
    return null
  }
}
